/* eslint-disable max-lines */
import React, { useState } from 'react';
import { FlatList, StyleSheet, Text, View } from 'react-native';

import { inject, observer } from 'mobx-react';

import AvatarComponent from '@components/AvatarComponent';
import CommentComponent from '@components/CommentComponent';
import { PostDetailItemContentLoading } from '@components/ContentLoading';
import EmptyComponent from '@components/EmptyComponent';
import ImageGroupPreview from '@components/FeedImage/ImageGroupPreview';
import { ScrollLoading } from '@components/index';
import TopicTag from '@components/TopicTag';
import { VideoComponent } from '@element/index';
import {
  alignItems,
  colors,
  fontSize,
  fontWeight,
  height,
  justifyContent,
  lineHeight,
  margin,
  textAlign
} from '@styles/common';
import helper from '@utils/helper';
import I18n from '@utils/i18n';
import p from '@utils/Transfrom';
import { FollowBtn } from '@widget/community';

import CellTradingInfo from './Components/CellTradingInfo';
import CommentInput from './Components/CommentInput';
import Like from './Components/Like';

import detailStyles from './index.module.less';

const T = (props) => {
  const {
    itemData = {},
    curLikeCount,
    isLoved,
    likeFun,
    comments,
    commentInputRef,
    fetchPostComment,
    fetchMoreComment,
    moreStatus,
    commentCount,
    setCommentCount,
    userStore: { userInfo = {} } = {}
  } = props;
  const { customerMisc } = itemData;
  const [visibleInput, setVisibleInput] = useState(''); // 评论、回复的输入框互斥，只能显示其中一个 这里存数据Id

  if (!itemData.id) {
    return (
      <div>
        <View>
          <PostDetailItemContentLoading />
        </View>
      </div>
    );
  }
  const identificationSource = helper.identificationSwitch(customerMisc.role);
  const avatar = customerMisc?.avatar || require('@images/defaultAvatar.webp');
  // const itemDataObj = helper.parseHTMLString(itemData.text.replace(/<p><br><\/p>/g, '<br><br>'))
  const itemDataObj = helper.parseHTMLString(itemData.text);
  const _renderVideo = (videoData, nodeTree) => {
    let videoSource = nodeTree?.child?.find((item) => item?.tag === 'source')
      ?.attr?.src;
    videoSource = videoSource || videoData?.videos?.[0];
    if (videoSource) {
      return <VideoComponent videoSource={videoSource} fluid={true} />;
    }
    return null;
  };
  const _renderHeader = () => {
    return (
      <View style={styles.headerWrap}>
        <View style={styles.headerIcon}>
          <AvatarComponent
            customerId={customerMisc?.customerId}
            avatar={avatar}
            avatarSize={40}
            identificationSource={identificationSource}
            identificationSize={14}
          />
          <View style={styles.headerCenter}>
            <Text style={styles.name}>
              <span className="DINPro">{customerMisc?.nickName ?? ''}</span>
            </Text>
            <View style={styles.timeAndIntroSection}>
              <Text style={[styles.title]}>
                <span className="DINPro">
                  {helper.toLocaleTime(itemData.timestamp, 'MM/DD HH:mm')}
                </span>
              </Text>
              {itemData.customerMisc?.intro ? (
                <Text style={[styles.intro, { marginLeft: p(16) }]}>
                  <span
                    className="DINPro"
                    style={{
                      maxWidth: '174px',
                      display: '-webkit-box',
                      overflow: 'hidden',
                      '-webkit-line-clamp': '1',
                      '-webkit-box-orient': 'vertical'
                    }}
                  >
                    {' '}
                    {itemData.customerMisc?.intro.split('\n')[0]}
                  </span>
                </Text>
              ) : null}
            </View>
          </View>
        </View>
        {userInfo.id !== customerMisc?.customerId && (
          <FollowBtn
            type="ghost"
            size="md"
            followedHidden
            isFollow={customerMisc?.follow}
            toCustomerId={customerMisc?.customerId}
            className={detailStyles.followBtn}
          />
        )}
      </View>
    );
  };
  const _renderTitle = () => {
    return itemData.title ? (
      <View>
        <Text style={styles.titleTextStyle}>
          <span className="DINPro">{itemData.title.replace(/\n/g, '')}</span>
        </Text>
      </View>
    ) : (
      <View style={{ height: p(40) }} />
    );
  };
  const _renderComments = () => {
    return (
      <View style={[styles.comment]}>
        <Text style={styles.headTitle}>
          <span className={'DINPro-Medium'}>{commentCount}</span>
          <span className={'DINPro-Medium'}>{I18n.t('eu2p41TW')}</span>
        </Text>
        <ScrollLoading
          itemClassName={styles.item}
          fetchData={fetchMoreComment}
          invisibleHeight={100}
          status={moreStatus}
        >
          <FlatList
            data={comments}
            ItemSeparatorComponent={() => {
              return (
                <View
                  style={{
                    height: 0,
                    borderBottomColor: '#E8EBF1',
                    borderBottomWidth: 0.5
                  }}
                />
              );
            }}
            renderItem={({ item, index }) => {
              return (
                <CommentComponent
                  commentData={item}
                  key={item.id}
                  {...props}
                  visibleInput={visibleInput}
                  setVisibleInput={setVisibleInput}
                  fetchPostComment={fetchPostComment}
                />
              );
            }}
            keyExtractor={(item, index) => {
              return index.toString();
            }}
            ListEmptyComponent={
              <EmptyComponent
                desc={I18n.t('noPostComment')}
                source={require('@images/noComment.webp')}
                style={styles.emptyComponentStyle}
                textStyle={styles.emptyTextStyle}
              />
            }
          />
        </ScrollLoading>
      </View>
    );
  };
  const _renderLike = () => {
    return (
      <View style={{ alignItems: 'center', marginTop: 40 }}>
        <Like
          type="2"
          curLikeCount={curLikeCount}
          isLoved={isLoved}
          likeFun={likeFun}
        />
      </View>
    );
  };
  const _renderTradingInfoContentView = () => {
    return <CellTradingInfo itemData={itemData} type="detail" />;
  };
  return (
    <div>
      <View>
        {_renderHeader()}
        {_renderTitle()}
        {itemData.subVerb === '15' ? _renderTradingInfoContentView() : null}

        {itemData.subVerb !== '15' &&
          itemDataObj.child.map((_item, _index) => {
            if (_item.node === 'text') {
              return (
                <div
                  key={_index}
                  className="DINPro"
                  style={{
                    color: '#1F2126',
                    fontSize: '16px',
                    letterSpacing: 0,
                    lineHeight: '32px',
                    marginBottom: 0,
                    wordBreak: 'break-all',
                    whiteSpace: 'pre-line'
                  }}
                  dangerouslySetInnerHTML={{ __html: _item.text }}
                />
              );
              // } else if (_item.node === 'element' && _item.tag === 'img' && _item.attr.src.startsWith('http')) {
            } else if (_item.node === 'element' && _item.tag === 'img') {
              let _photoItem = _item.attr.src;
              // TODO: 兼容交易打通数据------
              if (Array.isArray(_photoItem)) {
                _photoItem = _photoItem.join(' ');
              }
              // TODO: 兼容交易打通数据--------
              return (
                <View key={_index} style={{ marginBottom: p(18) }}>
                  <ImageGroupPreview
                    curSrc={_photoItem}
                    currentIndex={itemData.images.indexOf(_photoItem)}
                    previewImgGroup={itemData.images}
                  />
                </View>
              );
            } else if (_item.node === 'element' && _item.tag === 'video') {
              return (
                <View key={_index} style={{ marginBottom: p(18) }}>
                  {_renderVideo(itemData, _item)}
                </View>
              );
            } else {
              return <View key={_index} />;
            }
          })}
        <TopicTag itemData={itemData} />
        {_renderLike()}
        <CommentInput
          commentInputRef={commentInputRef}
          itemData={itemData}
          fetchPostComment={fetchPostComment}
          commentCount={commentCount}
          setCommentCount={setCommentCount}
        />
        {_renderComments()}
      </View>
    </div>
  );
};
export default inject((rootStore) => {
  return {
    userStore: rootStore.store.userStore
  };
})(observer(T));

const styles = StyleSheet.create({
  comment: {
    marginTop: p(40)
  },

  headTitle: {
    fontSize: 16,
    color: '#1F2126'
  },
  headerWrap: {
    height: height.h80,
    justifyContent: justifyContent.spaceBetween,
    alignItems: alignItems.center,
    flexDirection: 'row'
  },
  headerIcon: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  headerCenter: {
    marginLeft: margin.m20,
    justifyContent: justifyContent.center
  },
  timeAndIntroSection: {
    flexDirection: 'row',
    alignItems: alignItems.center
  },
  name: {
    fontSize: fontSize.f28,
    lineHeight: lineHeight.l36,
    color: colors.black3,
    fontWeight: fontWeight.f500,
    fontFamily: 'DINPro-Medium'
  },
  title: {
    fontSize: fontSize.f22,
    color: colors.gray1,
    lineHeight: lineHeight.l28
  },
  intro: {
    fontSize: fontSize.f20,
    color: colors.gray1,
    lineHeight: lineHeight.l26,
    maxWidth: p(350)
  },
  titleTextStyle: {
    color: colors.black,
    fontSize: 28,
    lineHeight: 40,
    fontFamily: 'DINPro-Bold',
    marginTop: 28,
    marginBottom: 20,
    fontWeight: 500
  },
  emptyComponentStyle: {
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: 80
  },
  emptyTextStyle: {
    textAlign: textAlign.center
  }
});
